import React from 'react';
import { X } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { CheckCircle } from 'lucide-react';

const PracticeAreaModal = ({ isOpen, onClose, areaData }) => {
  if (!areaData) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-gray-900 mb-2">
            {areaData.title}
          </DialogTitle>
          <DialogDescription className="text-gray-600 text-base">
            {areaData.description}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-6 mt-4">
          {/* Services Offered */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Services Offered:</h3>
            <ul className="space-y-2">
              {areaData.services && areaData.services.length > 0 ? (
                areaData.services.slice(0, 7).map((service, idx) => (
                  <li key={idx} className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-amber-600 mr-3 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">{service}</span>
                  </li>
                ))
              ) : (
                <li className="text-gray-600">Services information available upon consultation</li>
              )}
            </ul>
          </div>

          {/* How We Can Help */}
          <div className="bg-blue-50 p-4 rounded-lg">
            <h3 className="text-lg font-semibold text-blue-900 mb-2">How We Can Help:</h3>
            <p className="text-gray-700 leading-relaxed">{areaData.howWeHelp}</p>
          </div>

          {/* CTA */}
          <div className="flex gap-3 pt-2">
            <Button 
              onClick={onClose} 
              className="flex-1 bg-amber-600 hover:bg-amber-700"
            >
              Book Consultation
            </Button>
            <Button 
              onClick={onClose} 
              variant="outline"
              className="flex-1"
            >
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PracticeAreaModal;
